import { post, get, destroy, put, postAndValidateSuccess, BaseUrl } from './api'

const controllerName = "WorkflowDefenition";
export const getWorkflowResources = async () => {
    return await get(`${controllerName}/SmartFormWorkflows`, BaseUrl.WorkflowApi, { ignore404: true });
}